var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoveIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.3 5.08a6.57 6.57 0 0 0-10.44-1.71l-.86.78-.83-.76a6.53 6.53 0 0 0-5.69-1.8A6.45 6.45 0 0 0 .7 5.08a6.38 6.38 0 0 0 1.21 7.46l9.37 9.66a1 1 0 0 0 1.44 0l9.36-9.64a6.4 6.4 0 0 0 1.22-7.48Z"
})));
export { SvgLoveIt as ReactComponent };
export default __webpack_public_path__ + "8bf08d0d31ea7aaa713556a373d8ba216ecb89e245125dba0118b5fb46345628.svg";